import Signal from '../../assets/scripts/classes/Signal';

class InputSmsCode {
	constructor(el) {
		this.init(el);
	}

	init(el) {
		this.container = el;

		if (!this.container || this.container.inited) return;

		this.container.inited = true;

		this.container.smsCode = this;
		this.filled = new Signal();

		const inputs = this.container.querySelectorAll('input');
		this.inputs = inputs;

		const fillInputs = (code) => {
			code = code.slice(0, inputs.length);
			inputs.forEach((input, i) => {
				input.value = code[i] || '';
			});
			if (code.length === inputs.length) {
				inputs[inputs.length - 1].focus();
			}
		};

		const checkAndSubmit = () => {
			const code = Array.from(inputs)
				.map((i) => i.value)
				.join('');

			if (code.length === inputs.length) {
				this.filled.call(code);
			}
		};

		inputs.forEach((input, index) => {
			input.addEventListener('input', (e) => {
				const value = e.target.value.replace(/\D/g, '');
				e.target.value = value;

				if (value && index < inputs.length - 1) {
					inputs[index + 1].focus();
				}

				if (value.length > 1) {
					fillInputs(value);
				}

				checkAndSubmit();
			});

			input.addEventListener('keydown', (e) => {
				if (e.key === 'Backspace' && !input.value && index > 0) {
					inputs[index - 1].focus();
				}
			});

			input.addEventListener('paste', (e) => {
				e.preventDefault();

				const text = (e.clipboardData || window.clipboardData).getData('text').replace(/\D/g, '');

				fillInputs(text);
				checkAndSubmit();
			});
		});
	}
	reset() {
		this.inputs.forEach((input) => {
			input.value = '';
			input.dispatchEvent(new Event('change'));
		});
	}
}

document.querySelectorAll('[data-input-sms-code]').forEach((el) => new InputSmsCode(el));

export default InputSmsCode;
